module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/oxygen-1d87d7218861ebbf74650dca2f1f5a9a.svg";